import axios from "axios";

export async function fetchAllDataFromEndpoint(endpoint, data) {
  let allResponses = [];
  let nextLink = endpoint;
  try {
    while (nextLink) {
      const response = await axios.get(nextLink, data);
      allResponses = allResponses.concat(response.data.res.value);
      nextLink = response.data["@odata.nextLink"] || null;
    }
    return allResponses;
  } catch (error) {
    console.error(
      "Error fetching data:",
      error.response?.data || error.message
    );
    throw error;
  }
}
